import React from 'react';
import { Globe2Icon, InstagramIcon, MailIcon } from 'lucide-react';
const links = [{
  icon: MailIcon,
  label: 'support.tennisready@gmail.com',
  href: 'mailto:support.tennisready@gmail.com'
}, {
  icon: InstagramIcon,
  label: '@tennisready',
  href: 'https://instagram.com/tennisready'
}, {
  icon: Globe2Icon,
  label: 'www.tennisready.com',
  href: 'https://www.tennisready.com'
}];
export function Footer() {
  return <footer className="bg-ink-deep px-5 py-14 text-center" data-id="element-67" data-mp="3ud7h9vvh7slt">
      <div className="mx-auto max-w-4xl" data-id="element-68" data-mp="37fu95czww38">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-gold" data-id="element-69" data-mp="36czunggsbik">
          TENNIS READY™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-70" data-mp="3qcx9qes1cu4u">
          The #1 system for tennis coaches worldwide.
        </p>
        <p className="mt-2 text-sm italic text-slate-300" data-id="element-71" data-mp="29y5gy0qz9kv0">
          Because coaching tennis shouldn’t cost you every evening of the week.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-gold/20 py-6 text-sm font-semibold text-slate-300" data-id="element-72" data-mp="2evxa0y3czd0s">
          {links.map(({
          icon: Icon,
          label,
          href
        }) => <a key={label} href={href} className="flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-73" data-mp="3v7gg42ez4eac">
              <Icon className="h-4 w-4 text-gold" data-id="element-74" data-mp="830ibgbgg0zf" />
              {label}
            </a>)}
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-slate-500" data-id="element-75" data-mp="3477jvnjyo2y">
          © TENNIS READY™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}